import { useState } from "react";
import { useI18n } from "@/i18n";

interface Props {
  tags: string[];
  onChange: (tags: string[]) => void;
  placeholder?: string;
}

/** Chip-style tag input (PRD §5.2 services & procedures). */
export function TagInput({ tags, onChange, placeholder }: Props) {
  const { t } = useI18n();
  const [value, setValue] = useState("");

  function add() {
    const v = value.trim();
    if (v && !tags.includes(v)) onChange([...tags, v]);
    setValue("");
  }

  return (
    <div>
      <div className="mb-2 flex flex-wrap gap-2">
        {tags.map((tag) => (
          <span
            key={tag}
            className="inline-flex items-center gap-1 rounded-full bg-accent-soft px-3 py-1 text-sm text-accent"
          >
            {tag}
            <button
              type="button"
              className="text-accent/70"
              onClick={() => onChange(tags.filter((x) => x !== tag))}
              aria-label="remove"
            >
              ×
            </button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input
          className="input"
          value={value}
          placeholder={placeholder}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              add();
            }
          }}
        />
        <button type="button" className="btn-ghost px-4" onClick={add}>
          {t("addTag")}
        </button>
      </div>
    </div>
  );
}
